import { AuthSignInSubPage, AuthContentTitleWrapper, AuthContentTitle, AuthContentTitleIcon, AuthSignInButton, AuthMFASubtitle } from "../authBarStyling";
import { signInMenuActivatedSelector } from "../../../state/selectors/navbarToggle";
import { useRecoilState } from "recoil";
import { ColorTheme } from "../../globaStyledComponents/globalStyledComponentsStyling";

export default function AccountDeactivatedPopup() {
    const [, setSignInMenuActivated] = useRecoilState(signInMenuActivatedSelector);
    return (
        <div style={{ height: "100%" }}>
            <AuthSignInSubPage style={{ height: "100%" }}>
                <AuthContentTitleWrapper>
                    <AuthContentTitleIcon src={"https://d292awxalydr86.cloudfront.net/Branding/Ellipse+79.png"} alt={"Anystay logo"} />
                    <AuthContentTitle>Account deactivated.</AuthContentTitle>
                </AuthContentTitleWrapper>
                <AuthMFASubtitle style={{ marginTop: "8px", marginBottom: "311px" }}>
                    Your account is currently deactivated.
                    <br />
                    <a style={{ textDecoration: "underline", color: ColorTheme.Black.color, marginTop: "8px" }} href="https://help.anystay.com">
                        Get support
                    </a>
                </AuthMFASubtitle>
                <AuthSignInButton
                    type="button"
                    onClick={() => {
                        setSignInMenuActivated(false);
                    }}
                >
                    Continue
                </AuthSignInButton>
            </AuthSignInSubPage>
        </div>
    );
}
